import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './AboutUsPage.css';

const API_BASE_URL = '/api';

const AboutUsPage = () => {
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    title: 'About Us',
    description: 'Discover who we are, what we do, and the values that drive our journey.'
  });
  const [paragraphs, setParagraphs] = useState([]);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/settings/content/about-us`);
      if (response.ok) {
        const data = await response.json();
        setPageData({
          title: data.title || 'About Us',
          description: data.description || 'Discover who we are, what we do, and the values that drive our journey.'
        });
        
        let content = [];
        try {
          content = JSON.parse(data.content || '[]');
        } catch (e) {
          content = data.content ? [data.content] : [];
        }
        setParagraphs(content);
      }
    } catch (error) {
      console.error('Error fetching about us content:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="about-us-page">
      <Header />
      
      <main className="about-main-content">
        <div className="about-container">
          <div className="about-header">
            <h1 className="about-title">{pageData.title}</h1>
            <p className="about-subtitle">
              {pageData.description}
            </p>
          </div>
          
          <div className="about-content">
            {loading ? (
              <p className="about-paragraph">Loading...</p>
            ) : paragraphs.length > 0 ? (
              paragraphs.map((paragraph, index) => (
                <p key={index} className="about-paragraph">
                  {paragraph}
                </p>
              ))
            ) : (
              <p className="about-paragraph">
                At Conflux, we are dedicated to connecting businesses with the right 
                opportunities through trust, transparency, and innovation.
              </p>
            )}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutUsPage;
